import { Directive, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { addClass, removeClass } from '../../../utils/toggle-class/toggle-class';

@Directive({
  selector: '[appClearInput]',
  standalone: false
})
export class ClearInputDirective {
  private button: any;

  @Input() fromData: { form: UntypedFormGroup; control: any; isFormSubmitted: boolean };
  @Output() inputChanged: EventEmitter<string> = new EventEmitter();
  @Input() isClearInputHidden = false;

  constructor(private readonly el: ElementRef) {
    this.setup();
  }

  clearField() {
    this.fromData.form.controls[this.fromData.control].setValue('');
    this.inputChanged.emit('');
  }
  setup() {
    const parent = this.el.nativeElement.parentNode;
    this.button = document.createElement('span');
    this.button.setAttribute('class', 'input-clear-btn input-clear-btn--invisible');
    const closeIcon = document.createElement('i');
    closeIcon.classList.add('fa', 'fa-circle-xmark');
    this.button.appendChild(closeIcon);
    this.button.addEventListener('click', (event) => {
      this.clearField();
    });
    parent.insertBefore(this.button, parent.childNodes[0]);

    setTimeout(() => {
      this.checkErrorState();
      this.checkInvisibleState();

      this.fromData.form.controls[this.fromData.control].valueChanges.subscribe((val) => {
        this.checkErrorState();
        this.checkInvisibleState();
      });
    });
  }
  checkErrorState() {
    if (this.fromData.isFormSubmitted && this.fromData.form.controls[this.fromData.control].errors) {
      addClass('input-clear-btn--error', this.button);
    } else {
      removeClass('input-clear-btn--error', this.button);
    }
  }
  checkInvisibleState() {
    const isEmpty = this.fromData.form.controls[this.fromData.control].value === '';
    const hasValue = !!this.fromData.form.controls[this.fromData.control].value;

    if (isEmpty || !hasValue || this.isClearInputHidden) {
      addClass('input-clear-btn--invisible', this.button);
    } else {
      removeClass('input-clear-btn--invisible', this.button);
    }
  }
}
